import {
  AuthenticateResponse,
  AuthenticationMode,
  ConfigResponse,
  ENDPOINT_AUTHENTICATE,
  ENDPOINT_GET_CONFIG,
  ENDPOINT_LOGOUT,
  ENDPOINT_STATUS,
  ENDPOINT_VALIDATE_PHONE_NUMBER,
  Language,
  StatusResponse,
  ValidatePhoneNumberRequest,
  ValidatePhoneNumberResponse,
} from '@shared/types'
import { callEndpoint } from '@ui-common/utils/http/client'

/*
This file makes easier to verify that certain (hidden) endpoint is called from the app side since mocking does not need to be this:
import * as httpClient from '@ui-common/utils/http'
...
 expect(callEndpointSpy).toHaveBeenCalledWith(
        expect.objectContaining({ path: ENDPOINT_STATUS.path }),
        expect.any(Object),
      )

Instead mock the exact endpoint:
import * as endpoints from '@ui-common/api/endpoints'
vi.spyOn(endpoints, 'getStatus').mockResolvedValue(okStatusResponse)
 */

export const getStatus = (): Promise<StatusResponse> =>
  callEndpoint(ENDPOINT_STATUS, { requestConfig: { maxRetryAfterMs: 5000 } })

export const getConfig = async <TParam extends string>(
  sourceChannel: string,
  flow: string,
): Promise<ConfigResponse<TParam>> => callEndpoint(ENDPOINT_GET_CONFIG, { queryParams: { sourceChannel, flow } })

export const logout: () => Promise<void> = () => callEndpoint(ENDPOINT_LOGOUT)

export const authenticate: (lang: Language, authMode: AuthenticationMode) => Promise<AuthenticateResponse> = (
  lang: Language,
  authMode: AuthenticationMode,
) => callEndpoint(ENDPOINT_AUTHENTICATE, { queryParams: { lang, authMode } })

export const validatePhoneNumber = async (
  requestPayload: ValidatePhoneNumberRequest,
  abortSignal?: AbortSignal,
): Promise<ValidatePhoneNumberResponse> => {
  return callEndpoint(ENDPOINT_VALIDATE_PHONE_NUMBER, { requestPayload, abortSignal })
}
